/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Table, TableBody, TableCell, TableFooter, TableHead, TableHeader, TableRow, Theme } from 'bold-ui'
import { TableBox } from 'components/table/TableBox'
import { usePagedTableProps } from 'components/table/usePagedTableProps'
import theme from 'config/theme'
import { EvolucoesOdontoInput, EvolucoesOdontoTableQuery, PageInfo } from 'graphql/types.generated'
import { useMemo } from 'react'

import { EvolucoesOdontoTableHeader } from './EvolucoesOdontoTableHeader'
import { EvolucoesOdontoTableRow } from './EvolucoesOdontoTableRow'

export type EvolucoesOdontoRowItem = EvolucoesOdontoTableQuery['evolucoesOdonto']['content'][0]

export type EvolucoesOdontoModel = {
  content: EvolucoesOdontoTableQuery['evolucoesOdonto']['content']
  pageInfo: PageInfo
}

interface EvolucoesOdontoTableProps {
  loading: boolean
  result: EvolucoesOdontoTableQuery['evolucoesOdonto']
  filterState: EvolucoesOdontoInput
  onChange(filter: any): void
  onChangeFilter(filter: EvolucoesOdontoInput): void
}

export default function EvolucoesOdontoTable(props: EvolucoesOdontoTableProps) {
  const { loading, result, filterState, onChange, onChangeFilter } = props
  const classes = useMemo(() => createStyles(theme), [])

  const tableFooterProps = usePagedTableProps({
    loading,
    result: result as EvolucoesOdontoModel,
    onChange,
  })

  return (
    <TableBox header={<EvolucoesOdontoTableHeader filter={filterState} onChange={onChangeFilter} />}>
      <Table>
        <TableHead>
          <TableRow>
            <TableHeader style={classes.dataProcedColumn}>Data dos procedimentos</TableHeader>
            <TableHeader style={classes.localColumn}>Local</TableHeader>
            <TableHeader style={classes.procedColumn}>Procedimentos</TableHeader>
            <TableHeader style={classes.profColumn}>Profissional</TableHeader>
          </TableRow>
        </TableHead>
        <TableBody>
          {result && result.content?.length > 0 ? (
            result?.content.map((row, key) => <EvolucoesOdontoTableRow key={key} evolucaoOdonto={row} />)
          ) : (
            <TableRow>
              <TableCell colSpan={4} style={classes.emptyList}>
                Nenhum registro encontrado
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
      <TableFooter
        {...tableFooterProps}
        style={classes.tableFooter}
        pageSize={filterState.pageParams?.size}
        sizeOptions={[5, 15, 25, 50]}
      />
    </TableBox>
  )
}

const createStyles = (theme: Theme) => ({
  dataProcedColumn: css`
    max-width: 9.375 rem;
  `,

  localColumn: css`
    max-width: 6.875 rem;
  `,

  procedColumn: css`
    max-width: 13.75 rem;
  `,

  profColumn: css`
    max-width: 14.375 rem;
  `,

  emptyList: css`
    color: ${theme.pallete.gray.c40};
    text-align: center;
    font-style: italic;
  `,

  tableFooter: css`
    border-top: 0;
    background-color: ${theme.pallete.surface.main};
  `,
})
